import React from 'react'
import PropTypes from 'prop-types'
import {css} from '@emotion/react'
import { RowSM, RowMobileSM } from '../Row'
import { is_touch_device } from '../../utils'
import { fetchRelated, fetchRelatedVideos, fetchTranslationRelatedVideos, fetchVideoSimilarByTags } from '../../api'
import { Spinner } from 'reactstrap'
import Slider from 'react-slick'
import { Link } from 'gatsby'

class VideoRelatedVideoBox extends React.Component {
    static propTypes = {
        videoId: PropTypes.number,
    }

    state = {
        related: null,
        loading: true,
    }


    async componentDidMount() {
        const {videoId} = this.props
        const related = await fetchVideoSimilarByTags(videoId)
        if (related) {
            this.setState({
                related: related.results,
                loading: false
            })
        } else {
            this.setState({
                loading: false
            })
        }
    }
    
    render(){
        const {related} = this.state

        if(!related) return ""

        let message = ''
        if (!this.state.loading && related){
            if (!related.length) message = "Pas encore de vidéos similaires"
        }

        const videos = related.map(i => (
            <Link to={`/video/${i.id}`} state={{ videoId: i.id }} className="underline-not text-center mr-3" title="" style={{width:168}}>
                { i.image_size && i.image_size === "cover"
                    ? <div><img loading="lazy" className="" width="168" height="95" src={i.image}/></div>
                    : (
                        <div>
                            <div className="bg-placeholder" style={{width:168, height: "95px", backgroundImage: `url(${i.image})`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat:'no-repeat', filter:"blur(2px)"}}></div>
                            <div className="p-5 " style={{width:168, height: "95px", backgroundImage: `url(${i.image})`, backgroundPosition: 'left', backgroundSize: 'contain', backgroundRepeat:'no-repeat', marginTop: "-95px", position:"relative"}}></div>
                        </div>
                    )
                }
                {i.title}
                <span className="font-weight-bold ml-1">({i.type === 'trailer' ? 'bande annonce' : 'film' })</span> 
            </Link>
        ))

        return (
            <div className="container-fluid movie-page-container">
                <div className="row">
                    <div  id="video_et_description" className="mt-0 w-100">    
                        <div className="videoDescription p-4 pb-2 text-left font-weight-light ">
                            <h1>Videos similaires</h1>
                            { this.state.loading &&
                                <div className="m-auto text-center" style={{maxWidth: 1200}}>
                                    <Spinner className="m-auto text-center" size="sm"/>
                                </div>
                            }
                            <div className="movie-carousel y-scroll">
                                {videos}
                            </div>
                            <span>{message}</span>
                        </div>
                    </div>
            
                </div>
            </div>
        )
    }
}

const item = css({
    backgroundColor: '#FFFFFF',
    border: '1px solid rgba(0,0,0,0.2)',
    display: 'inline-block',
    marginRight: 10,
    position: 'relative',
    boxShadow: '0 1px 6px rgba(0,0,0,0.2)',
    fontSize: '0',
    // height: 98,
    // width: 67,
  })
  

export default VideoRelatedVideoBox


class RowVideo extends React.Component {

    render() {
      const settings = {
        className:"",
        slidesToShow: 6,
        slidesToScroll: 6,
        autoplay: false,
        dots: false,
        infinite: false,
        centerMode: false,
        variableWidth: true,
        variableHeight: true,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        centerPadding: "0px",
        responsive: [
          { breakpoint: 430,
              settings: { slidesToShow: 3, slidesToScroll: 2, }
          },
          { breakpoint: 540,
              settings: { slidesToShow: 3, slidesToScroll: 3, }
          },
          { breakpoint: 940,
              settings: { slidesToShow: 5, slidesToScroll: 4, }
          },
          { breakpoint: 1120,
              settings: { slidesToShow: 6, slidesToScroll: 5, }
          },
          { breakpoint: 1300, 
            settings: 
              { slidesToShow: 7, slidesToScroll: 6, }
          }
        ]
      }
  
      
      if (!this.props.movies || this.props.movies.length < 1) {
        return ''
      } else {
        const items = this.props.movies.map(movie => {
          const m = movie.slug ? movie : movie.node;
          return "Hello"
        })
  
        return (
          <div className="movie-carousel ">
            <Slider {...settings} className="m-0 p-0">
              {items}
            </Slider>
          </div>
        )
  
      }
    }
  }

const NextArrow = ({ onClick }) => <button type="button" className="movie-carousel-next" onClick={onClick} ></button>
const PrevArrow = ({ onClick }) => <button type="button" className="movie-carousel-prev" onClick={onClick} ></button>
